import { render } from "./AccountPage.vue?vue&type=template&id=71caf070&scoped=true"
import script from "./AccountPage.vue?vue&type=script&lang=js"
export * from "./AccountPage.vue?vue&type=script&lang=js"

import "./AccountPage.vue?vue&type=style&index=0&id=71caf070&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71caf070"]])

export default __exports__